// extracted by css-extract-rspack-plugin
export default {"title":"wI8oKfU4s4xK_47A","titleRow":"BlKXnpILwPMQpEpX","row":"bqY1ns3aApIxzhwx","card":"ccJ232Mr_lcWh8tW","eza":"PkvE6GtwVkaLTpjT","size":"_G36oxqx0LAdHl7V"};